<template>
  <div class="folderItem d-flex align-items-center justify-content-start w-100">
    <template v-if="!isImage && url">
      <a
        :href="url"
        target="_blank"
        style="text-decoration:none; color: #212529; width: 100%;"
        rel="noopener noreferrer"
      >
        <div class="leftContent w-100 d-flex align-items-center justify-content-start">
          <div class="icon">
            <font-awesome-icon v-if="type=='folder'" icon="folder" />
            <font-awesome-icon v-else-if="type=='file'" icon="file-alt" />
          </div>
          <div class="name">
            <span>{{ name }}</span>
          </div>
        </div>
      </a>
    </template>
    <template v-else>
      <div class="leftContent w-100 d-flex align-items-center justify-content-start">
        <div class="icon">
          <img v-if="isImage" :src="url" alt="thumbnail" class="thumbnail" />
          <font-awesome-icon v-else-if="type=='folder'" icon="folder" />
          <font-awesome-icon v-else-if="type=='file'" icon="file-alt" />
        </div>
        <div class="name">
          <span>{{ name }}</span>
        </div>
      </div>
    </template>
    <div class="rightContent d-flex align-items-center justify-content-end">
      <!-- <a :href="url" target="_blank" rel="noopener noreferrer" v-if="url">
        <font-awesome-icon icon="download" />
      </a>-->
      <div class="fileSize">
        <span>{{size}}</span>
      </div>
      <div class="delete" v-if="type=='file' && canDelete">
        <font-awesome-icon v-on:click.stop="deleteItem()" icon="trash" />
      </div>
      <div class="delete" v-if="type=='file' && canSelect">
        <input type="checkbox" :checked="selected" v-on:change.stop="selectItem"/>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "folder-item",
  props: {
    type: String,
    name: String,
    size: String,
    id: String,
    url: String,
    mimeType: String,
    canDelete: Boolean,
    canSelect: Boolean,
    selected: Boolean
  },
  mounted() {},
  computed: {
    isImage() {
      return this.mimeType?.startsWith("image/");
    },
  },
  methods: {
    deleteItem: function() {
      this.$emit("deleteItem", this.id);
    },
    selectItem: function() {
      this.selected = !this.selected;
      this.$emit("selectItem", this.id, this.selected);
    }
  }
};
</script>
<style lang="scss">
.thumbnail {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  margin-right: 1rem;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
}
.folderItem {
  padding: 1.5vh 3vw 1.5vh 1vw;
  position: relative;
  border-bottom: 1px solid #c4c4c4;
  .icon {
    color: #f2671c;
    font-size: 20px;
    min-width: 3vw;
  }
  .delete {
    color: red;
    font-size: 20px;
  }
  .delete:hover {
    cursor: pointer;
    color: #ef4f4f;
  }
  .fileSize {
    margin-right: 2vw;
  }
  .actions {
    position: absolute;
    right: 1vw;
    top: 1vh;
  }
}
.folderItem:hover {
  background-color: #f6f5f6;
  .leftContent {
    cursor: pointer;
  }
}
</style>
